import { useEffect } from 'react';

interface UseClickOutsideOptions {
  unless?: boolean | ((e: KeyboardEvent) => boolean);
  onPress: (e: KeyboardEvent) => void;
}

export default function useEscape({ unless, onPress }: UseClickOutsideOptions) {
  useEffect(() => {
    function handleOnPress(e: KeyboardEvent) {
      const shouldNotExecute = typeof unless === 'function' ? unless(e) : unless;

      if (shouldNotExecute || e.key !== 'Escape') {
        return;
      }

      onPress(e);
    }

    document.addEventListener('keyup', handleOnPress);

    return () => {
      document.removeEventListener('keyup', handleOnPress);
    };
  }, [unless]);
}
